import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgModel, Validators } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteActivatedEvent, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { debounceTime, distinctUntilChanged, map, Observable, startWith, Subject } from 'rxjs';
import { SuggestUser } from 'src/models/api-response/all-users-response.interface';
import { IGroup } from 'src/models/user/group.interface';
import { UtilService } from 'src/services/util.service';
import { ColorPickerModule } from 'primeng/colorpicker';
import { DivisionDetailsPayload, Office, OfficeCreate, OfficeType, PhoneDesk, PhoneDeskCreate, PhoneReportData, SectionDetailsPayLoad, SectionEmployees } from 'src/models/user/user-info.interface';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from 'src/services/user.service';
import { TokenStorageService } from 'src/services/token-storage.service';
import { Router } from '@angular/router';



@Component({
  selector: 'app-adminpanel',
  templateUrl: './adminpanel.component.html',
  styleUrl: './adminpanel.component.css',
 standalone:false
})
export class AdminpanelComponent implements OnInit {
   
  loading:boolean;
  colorDivisonId:number=0;
  userInfoForm:FormGroup;
  divisions: IGroup[];
  sections: IGroup[];
  divisionid:string;
  sectionid :string;
  textValue: string = '';
  sectionData : SectionDetailsPayLoad;
  sectionEmployees: SectionEmployees[];
  selectedSectionColor: string = '#1976d2';
  selectedDivisonColor: string = '#1976d2';
  divisonPayLoad! : DivisionDetailsPayload;
  divisionVisible : boolean;  // start enabled
    
  divisionFax: string|number = '';
  divisionPhone: string | number = '';
  divisionDeptAddress: string = '';
  divisionMapUrl: string = '';
  
  sectionVisible : boolean;   // start enabled

  fieldSelected : boolean;
  private searchTerms = new Subject<string>();
  displayItem = (i: SuggestUser | string | null) => (typeof i === 'string' ? i : i?.firstName ?? '');
  selectSectionId:number;
  sectiolist$!: Observable<IGroup[]>;
  private searchSection = new Subject<string>();
  displaySection = (i: IGroup | string | null) => (typeof i === 'string' ? i : i?.Name ?? '');

  
 
  // Other phone data 

  form!: FormGroup;
  records: PhoneReportData[] = [];
  editingId: number | null = null;
  submitting = false;
  successMsg = '';
  errorMsg = '';
  officeTypes: OfficeType[] = ['Emergency', 'Non-Emergency', 'None'];
  
  displayedColumns = [
      'name',
      'contractor',
      'bold',
      'order',
      'color',
       'visible'
    ];

  get f() { return this.form.controls; }

  offices: Office[] = [];
  loadingOffice = false;

  // ----- Office form state -----
  showOfficeForm = false;
  editingOfficeId: number | null = null;
  officeForm: OfficeCreate = this.blankOffice();

  // ----- Sub-grid state -----
  selectedOfficeId: number | null = null;
  phoneDesks: PhoneDesk[] = [];
  loadingDesks = false;

  // ----- PhoneDesk form state -----
  showDeskForm = false;
  editingDeskId: number | null = null;
  deskForm: PhoneDeskCreate = this.blankDesk();


  
  constructor(private router: Router,private userService: UserService,private tokenStorageService: TokenStorageService,private utilService:UtilService, private snackBar: MatSnackBar, private fb: FormBuilder)
  {
    this.userService.GetUserRoles(Number(this.tokenStorageService.getUserInfoId()))
    .subscribe(usr => {
      this.tokenStorageService.saveIsAdmin(usr.isDeveloper);
      if(!usr.isDeveloper)
      {
        this.router.navigate(['/my-profile']); 
      }
    });

    this.loading =false;
    this.selectSectionId=0;
    this.userInfoForm = new FormGroup ({ userName : new FormControl('',Validators.minLength(2)), divisionCtrl: new FormControl(''), sectionCtrl: new FormControl('')  });
    this.divisions = [];
    this.sectionEmployees =[];
    this.sections = [];
    this.sectionData = {
     sectionColor : '#1976d2',
     sectionEmployeeColor: '#1976d2',
     id :0,
     sectionId:0,
     divisionId:0,
     visible:true

    }  as SectionDetailsPayLoad;
    this.fieldSelected= false;
    this.divisionid ='';
    this.sectionid ='';
    this.sectionVisible = true;
    this.divisionVisible = true;
    this.loadOffices();
  }

  
 isStatusChecked(emp: SectionEmployees): boolean {
    return emp.userStatusId === 2;
  }

  onStatusToggle(emp: SectionEmployees, checked: boolean): void {
    emp.userStatusId = checked ? 2 : 1;
  }
  
  onBoldToggle(emp: SectionEmployees, checked: boolean): void {
    emp.boldSelected = checked;
  }
  onColorChange(emp: SectionEmployees, event: Event): void {
    const val = (event.target as HTMLInputElement).value;
    emp.employeeColor = val;
  }

  onVisibleToggle(emp: SectionEmployees, checked: boolean): void {
    emp.visible = checked;
  }

  
  setAllEmployeesColorInPlace(
    employees: SectionEmployees[],
    color: string | null
  ): void {
    for (const emp of employees) {
      emp.employeeColor = color;
    }
  }


  ngOnInit(): void {
  this.utilService.getAllDivisionsList().subscribe(res => {
       this.divisions = [];
       if (res.messageType != 'OK') {
         return;
       }
       this.divisions = this.utilService.setDivisionList(res);  
        
 });

 
 
 this.utilService.getSectionsList(0).subscribe(res => {
       this.sections = [];
       if (res.messageType != 'OK') {
         return;
       }
       this.sections = this.utilService.setSectionList(res); 
 
       this.sectiolist$ = this.searchSection.pipe(
         startWith(''),               // show results immediately
         debounceTime(200),           // wait for user to stop typing
         distinctUntilChanged(),
         map(term => term.toLowerCase()),
         map(term =>
           this.sections.filter(i =>
             i.Name.toLowerCase().includes(term)
           )
         )
       );
     });

     
    this.buildForm();
    this.loadAll();
    
  }

 searchSectionItem(term: string): void {
    this.selectSectionId=0;
    this.searchSection.next(term);
  }
  
onDivisionColorChanged(event: Event) {
  const value = (event.target as HTMLInputElement).value;
  this.selectedDivisonColor = value;
}


  onSectionColorChanged(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.selectedSectionColor = value;
  }

    onSectionColorEmployeeChanged(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.selectedSectionColor = value;
     this.setAllEmployeesColorInPlace(this.sectionEmployees, value);
  }

   onEmployeenColorEmployeeChanged(value: string) {
     this.selectedSectionColor = value;
     this.setAllEmployeesColorInPlace(this.sectionEmployees, value);
  }

 
  clear()
  {
    this.userInfoForm.controls['divisionCtrl'].setValue('');
    this.userInfoForm.controls['sectionCtrl'].setValue('');
    this.fieldSelected = false;
    this.divisionid ='';
    this.sectionid ='';
    this.colorDivisonId=0;
    this.reset();
  }

  onSectionSuggestionChanged(event: MatAutocompleteSelectedEvent) : void {
    if (event.option.value) 
    {
      let _section = event.option.value;
      let _SectionName = _section.Name;
      this.selectSectionId = _section.ID;
      this.sectionid = _section.ID;
      this.userInfoForm.controls['sectionCtrl'].patchValue(_SectionName);
      this.loadData();
    }
  }

     toInt(value:string) {
      const num = parseInt(value, 10);
      return isNaN(num) ? 0 : num;
    }    
    onDivisionChange(event: any) {
      this.divisionid = event.value;
      
      // If you also want the entire division object:
      const selectedDivision = this.divisions.find(d => d.ID === this.toInt(this.divisionid));
      this.colorDivisonId=0;
      this.loadData();
    }

    reset()
    {
      this.selectedDivisonColor  = '#1976d2';
        this.divisionFax='';
        this.divisionPhone ='';
        this.divisionMapUrl='';
        this.divisionDeptAddress='';
        this.colorDivisonId =0;
        this.loading =false;
        this.sectionData = {
              sectionColor : '#1976d2',
              sectionEmployeeColor: '#1976d2',
              id :0,
              sectionId:0,
              divisionId:0,
              visible:true

              }  as SectionDetailsPayLoad;
    }

  loadData()
  {

     if(this.divisionid =='' ||  this.sectionid =='')
     {
        this.fieldSelected =false;
        return;
     }
     this.fieldSelected =true;
     this.utilService.LoadDivisionPhoneListDetails(this.divisionid,this.sectionid).subscribe(res => {
     this.loading =true;
     this.divisonPayLoad =res;
     this.sectionEmployees = this.divisonPayLoad.sectionEmployees;
     this.normalizeOrdersPreserveExistingById(this.sectionEmployees);

     this.sectionEmployees = this.sectionEmployees.sort((a,b) => a.order -b.order);

       
        this.selectedDivisonColor = this.divisonPayLoad.divisonColor;
        this.colorDivisonId = this.divisonPayLoad.id;
        this.divisionFax= this.divisonPayLoad.fax == null? '': this.divisonPayLoad.fax;
        this.divisionPhone = this.divisonPayLoad.phone ==null ? '' : this.divisonPayLoad.phone;
        this.divisionMapUrl=this.divisonPayLoad.mapUrl;
        this.divisionDeptAddress=this.divisonPayLoad.deptAddress;
        if(this.divisonPayLoad.sectionData == null)
        {
        this.sectionData = {
            sectionColor : '#1976d2',
            sectionEmployeeColor: '#1976d2',
            id :0,
            sectionId:0,
            divisionId:0,
            visible:true

            }  as SectionDetailsPayLoad;
        }
        else
        {
            this.sectionData = this.divisonPayLoad.sectionData;
        }
       this.loading =false;
      });
  }


onColorTextBlur(event: FocusEvent) {
  const value = (event.target as HTMLInputElement)?.value ?? '';
  if (!value.trim()) {
    // Set to your preferred gray; adjust if you need a different shade
    this.selectedDivisonColor = '#cccccc';
  }
}


saveDivisionDetails() {
  const divisionId = this.userInfoForm?.get('divisionCtrl')?.value ?? null;
 
  this.sectionData.divisionId = divisionId;
  this.sectionData.sectionId =this.toInt(this.sectionid);

  const payload: DivisionDetailsPayload = {
    id:this.colorDivisonId,
    divisionId: divisionId,
    divisonColor: this.selectedDivisonColor,
    fax: this.divisionFax.toString(),
    phone: this.divisionPhone.toString(),
    deptAddress: this.divisionDeptAddress,
    mapUrl: this.divisionMapUrl,
    visible: this.divisionVisible,
    sectionData:this.sectionData,
    sectionEmployees:this.sectionEmployees
  };
  
    this.loading = true;
    this.utilService.SaveDivisonPhoneListDeatils(payload).subscribe(res => {
    if (res != 'SAVED') {
      this.snackBar.open('Error - Issue while saving the details', 'error', {
        duration: 5000
      });
      return;
    }
    this.snackBar.open('Successfully Updated the divison details', 'ok', {
      duration: 5000
    });
    this.clear();

    this.loading = false;
    
  }, error => {
    this.snackBar.open(`Error while saving the divison list: ${error}`, 'ok', {
      duration: 5000
    });
     this.loading = false;
  });
}

normalizeOrdersPreserveExistingById(sectionEmployees: SectionEmployees[]): void {
  // Track already used positive orders
  const used = new Set(
    sectionEmployees
      .map(e => e.order)
      .filter(o => typeof o === 'number' && o > 0)
  );

  // Next unused order number starting from 1
  const nextUnused = (() => {
    let n = 1;
    return () => {
      while (used.has(n)) n++;
      used.add(n);
      return n;
    };
  })();

  // Take only items with order === 0 (or falsy), sort them by id asc
  const zeros = sectionEmployees
    .filter(e => !e.order || e.order === 0)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  // Assign the next available order number
  zeros.forEach(e => {
    e.order = nextUnused();
  });
}

//other data


   private buildForm(): void {
    this.form = this.fb.group({
      officeName:  ['', [Validators.required, Validators.maxLength(150)]],
      officeType:  ['Emergency', Validators.required],
      phoneNo:     ['', [Validators.required, Validators.maxLength(20)]],
      fillColor:   ['#FF4444', Validators.required],
      borderColor: ['#CC0000', Validators.required]
    });
  }

  loadAll(): void {
    this.utilService.GetPhoneListOtherData().subscribe({
      next: data => (this.records = data),
      error: () => (this.errorMsg = 'Failed to load records.')
    });
  }


  onSubmit(): void {
    if (this.form.invalid) { this.form.markAllAsTouched(); return; }
    this.submitting = true;
    this.successMsg = '';
    this.errorMsg   = '';
    const payload = this.form.value;

    if (this.editingId !== null) {
      this.utilService.UpdatePhoneListOtherData(this.editingId, { id: this.editingId, ...payload }).subscribe({
        next:     () => { this.successMsg = 'Record updated!'; this.resetForm(); this.loadAll(); },
        error:    () => (this.errorMsg = 'Update failed.'),
        complete: () => (this.submitting = false)
      });
    } else {
      this.utilService.SavePhoneListOtherData(payload).subscribe({
        next:     () => { this.successMsg = 'Record saved!'; this.resetForm(); this.loadAll(); },
        error:    () => (this.errorMsg = 'Create failed.'),
        complete: () => (this.submitting = false)
      });
    }
  }

  editRecord(r: PhoneReportData): void {
    this.editingId = r.id;
    this.form.patchValue(r);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  deleteRecord(id: number): void {
    if (!confirm('Delete this record?')) return;

    this.utilService.DeletePhoneListOtherData(id).subscribe({
      next:  () => { this.successMsg = 'Deleted.'; this.loadAll(); },
      error: () => (this.errorMsg = 'Delete failed.')
    });
    this.resetForm();
  }

  resetForm(): void {
    this.editingId = null;
    this.form.reset({ officeType: 'Emergency', fillColor: '#FF4444', borderColor: '#CC0000' });
    this.submitting = false;
  }

  get sortedRecords(): PhoneReportData[] {
    const rank = (t: string) =>
      t === 'Emergency' ? 0 : t === 'Non-Emergency' ? 1 : 2;

    return [...this.records].sort((a, b) => {
      const r = rank(a.officeType) - rank(b.officeType);
      if (r !== 0) return r;
      // Within None group → alphabetical
      if (a.officeType === 'None') return a.officeName.localeCompare(b.officeName);
      return 0;
    });
  }


  //phone desk office and data

   // ================= OFFICE =================

  loadOffices(): void {
    this.loading = true;
    this.utilService.getOffices().subscribe({
      next: data => { this.offices = data; this.loading = false; },
      error: () => { this.loading = false; alert('Failed to load offices.'); }
    });
  }

  blankOffice(): OfficeCreate {
    return {
      officeName: '',
      fillColor: '#cce0ff',
      borderColor: '#0066ff',
      fontColor: '#000000'
    };
  }

  openAddOffice(): void {
    this.editingOfficeId = null;
    this.officeForm = this.blankOffice();
    this.showOfficeForm = true;
  }

  openEditOffice(o: Office): void {
    this.editingOfficeId = o.officeId;
    this.officeForm = {
      officeName: o.officeName,
      fillColor: o.fillColor,
      borderColor: o.borderColor,
      fontColor: o.fontColor
    };
    this.showOfficeForm = true;
  }

  cancelOfficeForm(): void {
    this.showOfficeForm = false;
    this.editingOfficeId = null;
  }

  saveOffice(): void {
    if (!this.officeForm.officeName.trim()) {
      alert('Office name is required.');
      return;
    }

    if (this.editingOfficeId == null) {
      this.utilService.createOffice(this.officeForm).subscribe({
        next: () => { this.showOfficeForm = false; this.loadOffices(); },
        error: err => alert(err?.error ?? 'Create failed.')
      });
    } else {
      this.utilService.updateOffice(this.editingOfficeId, this.officeForm).subscribe({
        next: () => { this.showOfficeForm = false; this.loadOffices(); },
        error: err => alert(err?.error ?? 'Update failed.')
      });
    }
  }

  deleteOffice(o: Office): void {
    if (!confirm(`Delete office "${o.officeName}"? This also removes its phone desks.`))
      return;
    this.utilService.deleteOffice(o.officeId).subscribe({
      next: () => {
        if (this.selectedOfficeId === o.officeId) this.selectedOfficeId = null;
        this.loadOffices();
      },
      error: () => alert('Delete failed.')
    });
  }

  // ================= PHONE DESK SUB-GRID =================

  selectOffice(o: Office): void {
    // toggle: clicking the same office closes the sub-grid
    if (this.selectedOfficeId === o.officeId) {
      this.selectedOfficeId = null;
      return;
    }
    this.selectedOfficeId = o.officeId;
    this.showDeskForm = false;
    this.editingDeskId = null;
    this.loadPhoneDesks(o.officeId);
  }

  loadPhoneDesks(officeId: number): void {
    this.loadingDesks = true;
    this.utilService.getPhoneDesks(officeId).subscribe({
      next: data => { this.phoneDesks = data; this.loadingDesks = false; },
      error: () => { this.loadingDesks = false; alert('Failed to load phone desks.'); }
    });
  }

  blankDesk(): PhoneDeskCreate {
    return { deskLocation: '', phoneNo: '' };
  }

  openAddDesk(): void {
    this.editingDeskId = null;
    this.deskForm = this.blankDesk();
    this.showDeskForm = true;
  }

  openEditDesk(d: PhoneDesk): void {
    this.editingDeskId = d.phoneDeskId;
    this.deskForm = { deskLocation: d.deskLocation, phoneNo: d.phoneNo };
    this.showDeskForm = true;
  }

  cancelDeskForm(): void {
    this.showDeskForm = false;
    this.editingDeskId = null;
  }

  saveDesk(): void {
    if (this.selectedOfficeId == null) return;
    if (!this.deskForm.deskLocation.trim()) {
      alert('Desk location is required.');
      return;
    }
    if (!this.deskForm.phoneNo.trim()) {
      alert('Phone number is required.');
      return;
    }

    if (this.editingDeskId == null) {
      this.utilService.createPhoneDesk(this.selectedOfficeId, this.deskForm).subscribe({
        next: () => {
          this.showDeskForm = false;
          this.loadPhoneDesks(this.selectedOfficeId!);
        },
        error: err => alert(err?.error ?? 'Create failed.')
      });
    } else {
      this.utilService.updatePhoneDesk(this.editingDeskId, this.deskForm).subscribe({
        next: () => {
          this.showDeskForm = false;
          this.loadPhoneDesks(this.selectedOfficeId!);
        },
        error: err => alert(err?.error ?? 'Update failed.')
      });
    }
  }

  deleteDesk(d: PhoneDesk): void {
    if (!confirm(`Delete phone desk "${d.deskLocation}"?`)) return;
     
    this.utilService.deletePhoneDesk(d.phoneDeskId).subscribe({
      next: (result) => {
        this.loadPhoneDesks(this.selectedOfficeId!);
        alert("Phone no# is deleted");
      },
      error: (err) => {
        alert('Delete failed.');
      }
    });

  }

  trackByOffice = (_: number, o: Office) => o.officeId;
  trackByDesk = (_: number, d: PhoneDesk) => d.phoneDeskId;



}
